import { TransactionProperty } from '@/features/InvoiceReport/Edit/type';
import {
  ApInvoiceTransactionGeneralInputForReport,
  useGetAllApInvoiceTransactionGeneralInputsSuspense,
} from 'ap-openapi';

const toNumberOrZero = (
  value: string | number | undefined,
  defaultValue: number
) => {
  if (value === undefined) return defaultValue;
  const num = Number(value);
  return Number.isNaN(num) ? defaultValue : num;
};

export const useGetTransactionProperties = (ap_report_id: string) => {
  const { data } = useGetAllApInvoiceTransactionGeneralInputsSuspense({
    ap_report_id: ap_report_id,
  });

  return {
    data:
      data.data.ap_invoice_transaction_general_inputs?.map(
        responseToTransactionProperty
      ) ?? [],
  };
};

const responseToTransactionProperty = (
  item: ApInvoiceTransactionGeneralInputForReport
): TransactionProperty => {
  return {
    id: item.id ?? '',
    label: item.label ?? '',
    isRequired: item.is_required ?? false,
    priority: item.priority ?? 0,
    componentType: item.component_type ?? '',
    columnWidth: item.column_width ?? 100,
    placeholder: item.placeholder ?? '',
    masterFieldName: item.master_field_name ?? '',
    type: item.type ?? 'basic',
    maxChars: toNumberOrZero(item.max_chars, 0),
    minChars: toNumberOrZero(item.min_chars, 0),
    dateFormatType: item.date_format_type ?? undefined,
    tooltipMessage: item.tooltip_message ?? '',
  };
};
